module.exports = __webpack_public_path__ + "img/speaker_9.98de6208.jpg";